"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scrollToEnd = void 0;
const index_1 = require("./index");
const scrollToEnd = (ivars, scrollView, animated = false) => {
    const scrollContainer = scrollView.parentElement;
    if (!scrollContainer) {
        return;
    }
    const delta = scrollContainer.offsetWidth - scrollContainer.scrollWidth;
    (0, index_1.scroll)(delta, ivars, scrollView, animated).then(() => {
        (0, index_1.updateScroll)(ivars, scrollView);
    });
};
exports.scrollToEnd = scrollToEnd;
